// Import the new pages
import HomePage from './pages/HomePage';
import PatientView from './pages/PatientView';
import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/common/Layout';
import ProtocolView from './pages/ProtocolView';
import theme from './theme';
import { SidebarProvider } from './components/common/sidebarContext';
import PatientProvider from './components/common/patientProvider';
import '../src/assets/styles/App.css';
import {Amplify} from 'aws-amplify';
import { Authenticator, withAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import awsExports from './aws-exports';
Amplify.configure(awsExports);




function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <PatientProvider>
          <SidebarProvider>
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="patients" element={<PatientView />} />
                <Route path="protocols" element={<ProtocolView />} />
              </Routes>
            </Layout>
          </SidebarProvider>
        </PatientProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default withAuthenticator(App);